module.exports = __webpack_public_path__ + "static/img/bg-overview@t.433ec62.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/bg-overview@t.jpg
// module id = G+jN
// module chunks = 0